import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../pages/Login.css"; // ✅ Asegúrate de que el CSS esté en la carpeta correcta

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;

      const response = await fetch(`${API_URL}/api/login/`, { 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("user", JSON.stringify(data.user));
        onLogin(data.user);
        navigate("/");
      } else {
        setError(data.error || "Error al iniciar sesión");
      }
    } catch (error) {
      setError("Error de conexión con el servidor");
    }
  };

  return (
    <div className="login-page">
      {/* 🔹 Header */}
      <header className="login-header">
        <img src="/logois.jpg" alt="Logo" className="logo" />
        <h1>Central Control Alarmas </h1>
      </header>

      {/* 🔹 Contenedor del formulario */}
      <div className="login-container">
        <div className="login-box">
          <img src="/logo.png" alt="Altura" className="tanla-logo" />
          <h2>Iniciar Sessión</h2>
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleSubmit}>
            <label>Usuario:</label>
            <input
              type="text"
              placeholder="Usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <label>Contraseña:</label>
            <input
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Entrar</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
